import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import Select from "react-select";
import {MatEditor} from "maticzeditor"
import config from "../../../lib/config";

const UpdatePlanModal = (props) => {
    const {onplanchange, Plans, customStyles, formValue, validateError, onChange, answer, onEditorChange, selectFileChange, preview_file, filepath, dummy, AddTire, InputCount, pushAndPopdata, pushAndPopAdd, handlechangeCheckBox, UpdatePlan} = props
    const [showModel, setShowModel] = useState(true)

  return (
    <div className='modals'>
            <Modal
                onHide={() => { props.onDismiss() }}
                show={showModel}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered>
                <Modal.Header closeButton onClick={() => props.onDismiss()}>
                    <Modal.Title>Add / Update Plan</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                <div className="newthememodal">
                        <div container>
                          <div container className="mt-1" spacing={1}>
                            <div item xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                              <Select
                                onChange={(e) => onplanchange(e)}
                                options={Plans}
                                label="Single select"
                                isSearchable={false}
                                styles={customStyles}
                                className="update_plan_top_slct"
                                classNamePrefix="react-select"
                                formControlProps={{
                                  fullWidth: true,
                                }}
                              />
                            </div>
                          </div>

                          <div
                            className="mt-3"
                            item
                            xxl={12}
                            xl={12}
                            lg={12}
                            md={12}
                            sm={12}
                            xs={12}
                          >
                            <div className="d-sm-flex">
                              <span className="labelspan mb-sm-0 mb-2 me-2">
                                Name of Plan
                              </span>{" "}
                              <input
                                type="text"
                                id="PackName"
                                value={formValue.PackName}
                                className="edit_inputs_align"
                                placeholder="Wallet Address*"
                                name="wallet address"
                                onChange={(e) => onChange(e)}
                              />

                            </div>
                            {
                              validateError.PackName && <span className="text-danger mtm-1">{validateError.PackName}</span>
                            }
                          </div>
                          <div
                            className="mt-3"
                            item
                            xxl={12}
                            xl={12}
                            lg={12}
                            md={12}
                            sm={12}
                            xs={12}
                          >
                            <div className="d-sm-flex ">
                              <div>
                                {" "}
                                <span className="labelspan mb-sm-0 mb-2 me-2">
                                  Display Name
                                </span>
                              </div>
                              <input
                                type="text"
                                id="displayName"
                                value={formValue.displayName}
                                className="edit_inputs_align"
                                placeholder="displayName*"
                                name="wallet address"
                                onChange={(e) => onChange(e)}
                              />

                            </div>
                            {
                              validateError.displayName && <span className="text-danger mtm-1">{validateError.displayName}</span>
                            }
                          </div>
                          <div
                            className="mt-3"
                            item
                            xxl={12}
                            xl={12}
                            lg={12}
                            md={12}
                            sm={12}
                            xs={12}
                          >
                            <div className="d-sm-flex">
                              <div>
                                {" "}
                                <span className="labelspan mb-sm-0 mb-2 me-2">
                                  Short Discription
                                </span>
                              </div>
                              <input
                                type="text"
                                id="ShortDiscription"
                                value={formValue.ShortDiscription}
                                className="edit_inputs_align"
                                placeholder="Short Discription*"
                                name="wallet address"
                                onChange={(e) => onChange(e)}
                              />

                            </div>
                            {
                              validateError.ShortDiscription && <span className="text-danger mtm-1">{validateError.ShortDiscription}</span>
                            }
                          </div>
                          <div
                            className="mt-3"
                            item
                            xxl={12}
                            xl={12}
                            lg={12}
                            md={12}
                            sm={12}
                            xs={12}
                          >
                            <div className="d-sm-flex">
                              <div>
                                <span className="labelspan mb-sm-0 mb-2 me-2">
                                  Description
                                </span>{" "}
                              </div>

                              {formValue.Discrption &&
                               <MatEditor sendata={formValue.Discrption} outdata={(evt) => onEditorChange(evt)} />
                                }
                            </div>
                            {
                              validateError.Discrption && <span className="text-danger mtm-1">{validateError.Discrption}</span>
                            }
                          </div>
                          <div
                            className="mt-3"
                            item
                            xxl={12}
                            xl={12}
                            lg={12}
                            md={12}
                            sm={12}
                            xs={12}
                          >
                            <div className="d-flex ">
                              <div>
                                {" "}
                                <span className="labelspan me-2">Currency</span>
                              </div>
                              <input
                                type="text"
                                id="Currency"
                                className="edit_inputs_align"
                                placeholder="Currency*"
                                value={formValue.Currency}
                                name="wallet address"
                                onChange={(e) => onChange(e)}
                              />

                            </div>
                            {
                              validateError.Currency && <span className="text-danger mtm-1">{validateError.Currency}</span>
                            }
                          </div>

                          <div
                            className="mt-3"
                            item
                            xxl={12}
                            xl={12}
                            lg={12}
                            md={12}
                            sm={12}
                            xs={12}
                          >
                            <div className="d-flex ">
                              <div>
                                <span className="labelspan me-2">Country</span>
                              </div>
                              <input
                                type="text"
                                id="Country"
                                className="edit_inputs_align"
                                placeholder="Enter Country*"
                                name="Country Name"
                                value={formValue.Country}
                                onChange={(e) => onChange(e)}
                              />

                            </div>
                            {
                              validateError.Country && <span className="text-danger mtm-1">{validateError.Country}</span>
                            }
                          </div>

                          <div
                            className="mt-3"
                            item
                            xxl={12}
                            xl={12}
                            lg={12}
                            md={12}
                            sm={12}
                            xs={12}
                          >
                            <div className="d-sm-flex">
                              <div className='mt-2'>
                                {" "}
                                <span className="labelspan me-2">Plan Image</span>
                              </div>
                              <div className="addplan_mdl_img_inp_dtls mt-2">
                                <span>Select File*</span>

                              </div>

                              <button className="admin_mdl_red_btn admn_img_upld_btn mt-2">
                                Upload
                                <input
                                  className="addplan_mdl_img_inp addpln_hidden_dtl"
                                  type="file"
                                  name="file"
                                  accept="image/*"
                                  onChange={selectFileChange}
                                />
                              </button>

                            </div>
                          </div>
                          <div
                            className="mt-3"
                            item
                            xxl={12}
                            xl={12}
                            lg={12}
                            md={12}
                            sm={12}
                            xs={12}
                          >
                            <div className="d-sm-flex">
                              <div className="me-2">
                                {" "}
                                <img
                                  src={
                                    preview_file
                                      ? preview_file
                                      : filepath
                                        ? config.Back_Url + "/" + filepath
                                        : dummy
                                  }
                                  style={{ width: 117 }}
                                />
                              </div>
                              <p style={{ fontWeight: "500" }}>
                                Image Dimension <br /> (150 X 150)
                              </p>
                            </div>
                          </div>

                          <div
                            className="mt-3"
                            item
                            xxl={12}
                            xl={12}
                            lg={12}
                            md={12}
                            sm={12}
                            xs={12}
                          >
                            <div className=" ">
                              {[...Array(InputCount)].map((val, index) => {
                                return (
                                  <div className="d-sm-flex align-items-center mb-2">
                                    <p className="shrink-0 mb-0 f-12 fw-600 me-2 mt-sm-0 mt-2">
                                      Units
                                    </p>
                                    <input
                                      type="text"
                                      id={"units" + index}
                                      className="edit_inputs_align me-2 mb-2 mb-sm-0"
                                      placeholder="Enter units*"
                                      value={AddTire["units" + index]}
                                      name="wallet address"
                                      onChange={(e) => pushAndPopdata(e, index)}
                                    />
                                  
                                    { }
                                    <p className="shrink-0 mb-0 f-12 fw-600 me-2">
                                      Price per Unit
                                    </p>
                                    <input
                                      type="text"
                                      id={"Price" + index}
                                      className="edit_inputs_align me-2 mb-2 mb-sm-0"
                                      placeholder="Enter Price*"
                                      name="wallet address"
                                      value={AddTire["Price" + index]}
                                      onChange={(e) => pushAndPopdata(e, index)}
                                    />

                                    <button
                                      className="admin_mdl_red_btn"
                                      onClick={() => {
                                        pushAndPopAdd(index);
                                      }}
                                    >
                                      Add Tier
                                    </button>
                                  </div>
                                );
                              })}
                            </div>
                          </div>





                          <div
                            className="mt-3"
                            item
                            xxl={12}
                            xl={12}
                            lg={12}
                            md={12}
                            sm={12}
                            xs={12}
                          >
                            <div className="d-sm-flex ">
                              <div>
                                {" "}
                                <span className="labelspan mb-sm-0 mb-2 me-2">
                                  SetUp fee
                                </span>
                              </div>
                              <input
                                type="text"
                                id="Price"
                                value={formValue.Price}
                                className="edit_inputs_align me-2"
                                placeholder="Wallet Address*"
                                name="wallet address"
                                onChange={(e) => onChange(e)}
                              />

                            </div>
                            {
                              validateError.Price && <span className="text-danger mtm-1">{validateError.Price}</span>
                            }
                          </div>
                        </div>
                        <div className="table_div_head mt-4">
                          <div class="container-fluid edit_table_container_align">
                            <div
                              class="table-responsive"
                              style={{ position: "relative", zIndex: 0 }}
                            >
                              <table class="table edit_user_table_align">
                                <thead className="tiffany_thead">
                                  <tr>
                                    <th scope="col">LazyMint ERC721 & ERC 1155</th>
                                    <th scope="col">Bulk LazyMint SoulBound Tokens</th>
                                    <th scope="col">Bulk Minting</th>
                                    <th scope="col">Token Scanner</th>
                                    <th scope="col">DashBoard And Profile</th>
                                    <th scope="col">Campaign Page</th>
                                  </tr>
                                </thead>
                              
                                <tbody>
                                  <tr>
                                    {
                                      formValue.ERC == 'true' ?
                                        <td><input type="checkbox" className='table_check_align' id="ERC" name="ERC" value="ERC" checked="checked" onChange={(e) => handlechangeCheckBox(e)} /></td>
                                        :
                                        <td><input type="checkbox" className='table_check_align' id="ERC" name="ERC" value="ERC" onChange={(e) => handlechangeCheckBox(e)} /></td>

                                    }

                                    {
                                      formValue.Soulbound == 'true' ?
                                        <td><input type="checkbox" className='table_check_align' id="Soulbound" name="Soulbound" checked="checked" onChange={(e) => handlechangeCheckBox(e)} /></td>
                                        :
                                        <td><input type="checkbox" className='table_check_align' id="Soulbound" name="Soulbound" onChange={(e) => handlechangeCheckBox(e)} /></td>

                                    }


                                    {
                                      formValue.Bulkminting == 'true' ?
                                        <td><input type="checkbox" className='table_check_align' id="Bulkminting" name="Bulkminting" checked="checked" onChange={(e) => handlechangeCheckBox(e)} /></td>
                                        :
                                        <td><input type="checkbox" className='table_check_align' id="Bulkminting" name="Bulkminting" onChange={(e) => handlechangeCheckBox(e)} /></td>

                                    }



                                    {
                                      formValue.TokenScanner == 'true' ?
                                        <td><input type="checkbox" className='table_check_align' id="TokenScanner" name="TokenScanner" checked="checked" onChange={(e) => handlechangeCheckBox(e)} /></td>
                                        :
                                        <td><input type="checkbox" className='table_check_align' id="TokenScanner" name="TokenScanner" onChange={(e) => handlechangeCheckBox(e)} /></td>

                                    }


                                    {
                                      formValue.DashBoardAndProfile == 'true' ?
                                        <td><input type="checkbox" className='table_check_align' id="DashBoardAndProfile" checked="checked" name="DashBoardAndProfile" onChange={(e) => handlechangeCheckBox(e)} /></td>
                                        :
                                        <td><input type="checkbox" className='table_check_align' id="DashBoardAndProfile" name="DashBoardAndProfile" onChange={(e) => handlechangeCheckBox(e)} /></td>

                                    }

                                    {
                                      formValue.DomainCampaign == 'true' ?
                                        <td><input type="checkbox" className='table_check_align' id="DomainCampaign" checked="checked" name="DomainCampaign" onChange={(e) => handlechangeCheckBox(e)} /></td>
                                        :
                                        <td><input type="checkbox" className='table_check_align' id="DomainCampaign" name="DomainCampaign" onChange={(e) => handlechangeCheckBox(e)} /></td>

                                    }


                                  </tr >
                                </tbody >
                              </table >
                            </div >
                          </div >
                        </div >
                        <div className="text-right">
                          {" "}
                          <button
                            className="admin_mdl_red_btn mt-4"
                            onClick={() => {
                              UpdatePlan();
                            }}
                          >
                            Confirm
                          </button>
                        </div>
                      </div >
                </Modal.Body>

            </Modal>

    </div>
  )
}

export default UpdatePlanModal